/* ============================================================
   e11ement Pets — one-pager interactivity (plain vanilla JS)
   Rebuilt from the original prototype's component logic.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Product data ---- */
  var sizeData = [
    { name: '1 oz', price: 7.99,  tag: 'Travel size' },
    { name: '2 oz', price: 9.99,  tag: 'Trial' },
    { name: '4 oz', price: 14.99, tag: 'Everyday' },
    { name: '8 oz', price: 19.99, tag: 'Most popular' },
    { name: '1 L',  price: 29.99, tag: 'Best value' }
  ];
  var gallery = [
    'images/bottle.jpg',
    'images/golden-towel.jpg',
    'images/apply-cat.jpg',
    'images/size-lineup.jpg'
  ];

  /* ---- State (defaults match the original) ---- */
  var state = { img: 0, size: 3, plan: 'sub', qty: 1, openFaq: 0 };

  var fmt = function (n) { return '$' + n.toFixed(2); };
  var $  = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var SELECTED_BORDER = '2px solid #E8A98F';

  /* ---- Order box rendering ---- */
  function updateOrderUI() {
    var size = sizeData[state.size];
    var unit = state.plan === 'sub' ? size.price * 0.85 : size.price;

    var orderImage = $('#orderImage');
    if (orderImage) orderImage.src = gallery[state.img];

    $$('[data-action="thumb"]').forEach(function (btn) {
      var i = parseInt(btn.getAttribute('data-i'), 10);
      btn.style.border = (i === state.img) ? SELECTED_BORDER : '2px solid #FFFFFF';
    });

    $$('[data-action="size"]').forEach(function (btn) {
      var i = parseInt(btn.getAttribute('data-i'), 10);
      var on = (i === state.size);
      btn.style.background = on ? '#FDF9F5' : '#FFFFFF';
      btn.style.border = on ? SELECTED_BORDER : '2px solid #F2F2F2';
    });

    var planSub = $('#planSub'), planOne = $('#planOne');
    if (planSub) {
      planSub.style.background = state.plan === 'sub' ? '#FDF9F5' : '#FFFFFF';
      planSub.style.border = state.plan === 'sub' ? SELECTED_BORDER : '2px solid #F2F2F2';
    }
    if (planOne) {
      planOne.style.background = state.plan === 'one' ? '#FDF9F5' : '#FFFFFF';
      planOne.style.border = state.plan === 'one' ? SELECTED_BORDER : '2px solid #F2F2F2';
    }

    var setText = function (sel, val) { var el = $(sel); if (el) el.textContent = val; };
    setText('#sizeLabel', size.name);
    setText('#stickySize', size.name);
    setText('#subPrice', fmt(size.price * 0.85));
    setText('#onePrice', fmt(size.price));
    setText('#qty', String(state.qty));
    setText('#stickyPrice', fmt(unit * state.qty));
  }

  /* ---- FAQ accordion (single open) ---- */
  function applyFaqUI() {
    $$('.faq-q').forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-i'), 10);
      var open = (idx === state.openFaq);
      var answer = btn.nextElementSibling;
      if (answer) answer.style.display = open ? '' : 'none';
      var marks = btn.querySelectorAll('span');
      var mark = marks[marks.length - 1];
      if (mark) mark.style.transform = open ? 'rotate(45deg)' : 'rotate(0deg)';
    });
  }
  function toggleFaq(i) {
    state.openFaq = (state.openFaq === i) ? -1 : i;
    applyFaqUI();
  }

  /* ---- Mobile nav ---- */
  function setMobileNav(open) {
    var panel = $('#mobileNav');
    if (panel) panel.style.display = open ? 'flex' : 'none';
  }

  /* ---- Add to cart ---- */
  var cartTimer = null;
  function addToCart() {
    var btn = $('#addToCart');
    if (!btn) return;
    btn.classList.add('added-pulse');
    btn.textContent = '\u2713 Added to Cart';
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      btn.textContent = 'Add to Cart';
      btn.classList.remove('added-pulse');
    }, 2000);
  }

  /* ---- Click delegation ---- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-action]');
    if (!el) return;
    var action = el.getAttribute('data-action');
    var i = el.getAttribute('data-i');

    switch (action) {
      case 'thumb': state.img = parseInt(i, 10); updateOrderUI(); break;
      case 'size':  state.size = parseInt(i, 10); updateOrderUI(); break;
      case 'plan':  state.plan = el.getAttribute('data-plan'); updateOrderUI(); break;
      case 'dec':   state.qty = Math.max(1, state.qty - 1); updateOrderUI(); break;
      case 'inc':   state.qty = Math.min(9, state.qty + 1); updateOrderUI(); break;
      case 'addcart': addToCart(); break;
      case 'faq':   toggleFaq(parseInt(i, 10)); break;
      case 'togglenav': {
        var panel = $('#mobileNav');
        setMobileNav(!(panel && panel.style.display === 'flex'));
        break;
      }
      case 'closenav': setMobileNav(false); break;
    }
  });

  /* ---- Sticky mini-cart bar + hero parallax ---- */
  function onScroll() {
    var bar = $('#stickyBar');
    var past = window.scrollY > 700;
    var nearOrder = (function () {
      var el = document.getElementById('order');
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight * 0.7 && r.bottom > window.innerHeight * 0.3;
    })();
    if (bar) bar.style.display = (past && !nearOrder) ? 'block' : 'none';

    var heroDecor = document.getElementById('heroDecor');
    if (heroDecor) {
      heroDecor.style.transform = 'translateY(' + Math.min(50, window.scrollY * 0.08) + 'px)';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---- Scroll-reveal ---- */
  function initReveals() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    $$('.reveal, .reveal-left, .reveal-right, .reveal-child').forEach(function (el) {
      if (!el.classList.contains('is-visible')) io.observe(el);
    });
  }

  /* ---- Init ---- */
  function init() {
    updateOrderUI();
    applyFaqUI();
    initReveals();
    onScroll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
